import {ConfigFilenamePrefix, DestinationPrefix} from "@rezonence/sdk";

export const s3PrefixMap: Record<ConfigFilenamePrefix, DestinationPrefix> = {
    Pb: DestinationPrefix.Pub,
    Ad: DestinationPrefix.Ads
}
